import { useCallback, useState } from "react";
import { isBrowser } from "../helpers";
import useEventListener from "./useEventListener";

export type TScrollDirection = "down" | "up";

export default function useScrollDir(): TScrollDirection {
  const [scrollDir, setScrollDir] = useState<TScrollDirection>("down");
  const [oldScrollPos, setScrollPos] = useState(() =>
    isBrowser() ? window.scrollY : 0,
  );
  const handleScroll = useCallback(() => {
    if (oldScrollPos > window.scrollY) {
      setScrollDir("up");
    } else {
      setScrollDir("down");
    }
    setScrollPos(window.scrollY);
  }, [oldScrollPos]);
  useEventListener("scroll", handleScroll);

  return scrollDir;
}
